import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwd-web-applications',
  templateUrl: './web-applications.component.html',
  styleUrls: ['./web-applications.component.scss']
})
export class WebApplicationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
